import { jsxs as m, jsx as e, Fragment as S } from "react/jsx-runtime";
import { c as t } from "../../../index-2QXL0WYc.js";
import { GlobalCSSClass as l } from "../../../enums.js";
import { propagateTestid as x } from "../../../helpers/utility/propagateTestid.js";
import { useState as y } from "react";
const q = "ids-label-v5150", R = "ids-label--hidden-v5150", g = "ids-label--has-append-v5150", A = "ids-label--required-v5150", C = "ids-label--optional-v5150", a = {
  label: q,
  hidden: R,
  hasAppend: g,
  required: A,
  optional: C
}, G = ({
  append: i,
  as: h = "label",
  children: u,
  className: b,
  "data-testid": d,
  hiddenLabel: s = !1,
  optional: r,
  required: p,
  ...f
}) => {
  const [c, N] = y(), v = (n) => {
    const o = n == null ? void 0 : n.textContent;
    o && o !== c && N(o);
  };
  return /* @__PURE__ */ m(
    h,
    {
      className: t(b, l.FormLabel, {
        [a.label]: !0,
        [a.hidden]: s,
        [a.hasAppend]: i
      }),
      ...f,
      "data-name": c,
      "data-testid": d,
      children: [
        p && /* @__PURE__ */ m(S, { children: [
          !s && /* @__PURE__ */ e("span", { className: t(a.required), "aria-hidden": "true", children: "*" }),
          /* @__PURE__ */ e("span", { className: l.SROnly, children: "Required " })
        ] }),
        /* @__PURE__ */ e(
          "span",
          {
            className: t({
              [l.SROnly]: s === !0
            }) || void 0,
            "data-testid": x(d, "text"),
            ref: v,
            children: u
          }
        ),
        !p && r && /* @__PURE__ */ e(
          "span",
          {
            className: t(a.optional, {
              [l.SROnly]: s === !0
            }),
            children: typeof r == "string" ? r : "(optional)"
          }
        ),
        i
      ]
    }
  );
};
export {
  G as LabelBase
};
